/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationEnrollmentCancelObservation202,
  PutApiV1CourseregistrationEnrollmentCancelObservation400,
  PutApiV1CourseregistrationEnrollmentCancelObservation401,
  PutApiV1CourseregistrationEnrollmentCancelObservation500,
  PutApiV1CourseregistrationEnrollmentCancelObservationMutationRequest,
  PutApiV1CourseregistrationEnrollmentCancelObservationMutationResponse,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCancelObservation.ts";
import { courseRegistrationEditCancelObservationViewModelSchema } from "../courseRegistrationEditCancelObservationViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationEnrollmentCancelObservation202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCancelObservation202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationEnrollmentCancelObservation400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCancelObservation400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationEnrollmentCancelObservation401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCancelObservation401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationEnrollmentCancelObservation500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCancelObservation500>;

export const putApiV1CourseregistrationEnrollmentCancelObservationMutationRequestSchema =
  z.lazy(
    () => courseRegistrationEditCancelObservationViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCancelObservationMutationRequest>;

export const putApiV1CourseregistrationEnrollmentCancelObservationMutationResponseSchema =
  z.lazy(
    () => putApiV1CourseregistrationEnrollmentCancelObservation202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCancelObservationMutationResponse>;
